import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Response } from '@angular/http';
import { ClientModel } from '../../shared/models/client.model';
import { OauthService } from '../../shared/services/oauth.service';
import { PointsService } from '../../shared/services/points.service';

/**
 * Points statement page (/account/points): summary card on top plus the
 * paginated statement — date, description, signed amount (direction from the
 * API), validity and a link to the originating order. Guarded by the store
 * gate: without the program the route redirects to the account home.
 */
@Component({
    selector: 'account-points',
    templateUrl: './account.points.component.html',
    styleUrls: ['./../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountPointsComponent implements OnInit {
    public client: ClientModel;
    public rows: Array<any> = [];
    public loading = false;
    public hasMoreToLoad = false;
    private currentPage = 0;

    constructor(
        protected translate: TranslateService,
        protected titleService: Title,
        protected router: Router,
        protected oauth: OauthService,
        protected points: PointsService,
        protected activatedRoute: ActivatedRoute
    ) {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.oauth.init();
            }
        });

        this.translate.get('ACCOUNT.POINTS.TITLE').subscribe((title: string) => {
            this.titleService.setTitle(title + ' | ' + this.activatedRoute.snapshot.data.storeConfigurations.store_name);
        });
        this.oauth.loadedAuthenticatedUser$.subscribe((client: ClientModel) => {
            this.client = client;
            this.loadMore();
        });
        this.oauth.failedAuthenticatedUser$.subscribe((error: Response) => {
            this.redirectOnFailAuthentication(error.status);
        });
        this.oauth.failedPersistedUser$.subscribe((error: Response) => {
            this.redirectOnFailAuthentication(error.status);
        });
        this.oauth.tokenRefused$.subscribe(() => {
            this.redirectOnFailAuthentication();
        });
    }

    ngOnInit() {
        const configurations = this.activatedRoute.snapshot.data['storeConfigurations'] || {};
        if (!+configurations['points-program-enabled']) {
            window.location.href = '/account/profile';
        }
    }

    /**
     * Data de liberacao da linha, SO enquanto ainda esta em carencia (entrada
     * com valid_from no futuro) — o "quando esses pontos entram" que o extrato
     * mostra por linha.
     */
    public releaseDate(row): string {
        if (row.direction !== 'in' || !row.valid_from) {
            return null;
        }

        return new Date(row.valid_from) > new Date() ? row.valid_from : null;
    }

    public loadMore() {
        if (!this.client || !this.client.id) {
            return;
        }

        this.loading = true;
        this.points
            .statement(+this.client.id, this.currentPage + 1)
            .subscribe((response: Response) => {
                const rows = response.json().data;
                const pagination = response.json().meta['pagination'];

                for (let index in rows) {
                    if (rows.hasOwnProperty(index)) {
                        this.rows.push(rows[index]);
                    }
                }

                this.currentPage = pagination['current_page'];
                this.hasMoreToLoad = pagination['current_page'] < pagination['last_page'];
                this.loading = false;
            }, () => {
                this.loading = false;
            });
    }

    private redirectOnFailAuthentication(statusCode = 401) {
        if (statusCode === 401) {
            window.location.href = '/';
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src1143190010/src/src/app/account/points/account.points.component.ts